import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Save, FileText } from "lucide-react";

export default function AdminTemplates() {
  const [templates, setTemplates] = useState([]);
  const [active, setActive] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "" });

  const load = () => api.get("/admin/templates").then((r) => { setTemplates(r.data); if (!active && r.data[0]) selectT(r.data[0]); });
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const selectT = (t) => { setActive(t.opportunity_type); setForm({ subject: t.subject, body: t.body }); };

  const save = async () => {
    try {
      await api.post("/admin/templates", { opportunity_type: active, subject: form.subject, body: form.body });
      toast.success("Template saved"); load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Email Templates" subtitle="Approved marketing copy per mortgage opportunity. The compliance footer is appended automatically." />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <Card className="p-2 lg:col-span-4">
          {templates.map((t) => (
            <button key={t.opportunity_type} onClick={() => selectT(t)} data-testid={`template-${t.opportunity_type.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-left text-sm font-medium transition-colors ${active === t.opportunity_type ? "bg-amber-50 text-amber-900" : "text-slate-600 hover:bg-slate-50"}`}>
              <FileText className="h-4 w-4" /> {t.opportunity_type}
            </button>
          ))}
        </Card>
        <Card className="p-6 lg:col-span-8">
          {active ? (
            <>
              <h3 className="mb-4 font-display font-bold text-slate-900">{active}</h3>
              <Label>Subject</Label>
              <Input className="mb-4 mt-1.5" value={form.subject} onChange={(e) => setForm((f) => ({ ...f, subject: e.target.value }))} data-testid="template-subject" />
              <Label>Body <span className="text-xs font-normal text-slate-400">(use {"{{name}}"} for the prospect's name)</span></Label>
              <Textarea className="mt-1.5" rows={10} value={form.body} onChange={(e) => setForm((f) => ({ ...f, body: e.target.value }))} data-testid="template-body" />
              <div className="mt-3 rounded-lg border border-dashed border-slate-200 bg-slate-50 p-3 text-xs text-slate-500">
                Footer auto-appended: sending MLO's name &amp; NMLS, Elite Real Estate &amp; Finance LLC (NMLS #2863463), business address, and an unsubscribe line.
              </div>
              <Button className="mt-4 gold-cta border-0 font-bold" onClick={save} data-testid="save-template-btn"><Save className="mr-2 h-4 w-4" /> Save Template</Button>
            </>
          ) : <p className="text-sm text-slate-400">Select a template.</p>}
        </Card>
      </div>
    </div>
  );
}
